const groupFilterStyles = {
  formControl: {
    minWidth: 200,
  },
}

export default groupFilterStyles
